import { FormFieldConfig } from '../types'
import { Field } from '@components/gassan-ui'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'

type PhoneFieldProps = {
  field: FormFieldConfig
}

export const PhoneField: FC<PhoneFieldProps> = ({ field }) => {
  const { t } = useTranslation('forms')

  const getLabel = (): string => {
    return field.mandatory
      ? t('labels.phone')
      : `${t('labels.phone')} - ${t('optional', { ns: 'forms' })}`
  }

  return (
    <Field
      name="phoneNumber"
      label={getLabel()}
      field="input"
      gridColumn="span 12"
      inputMode="tel"
      autoComplete="tel"
    />
  )
}
